let importer;

export const createCSVImportCallback = (
  entityName,
  importFunction,
  successCallback,
  errorCallback,
  entityListId = -1,
  validateData = null,
  config = {},
  source = null,
) => {
  return async (result, data) => {
    if (result) {
      if (data.import_id) {
        try {
          let validatedData = data;
          if (validateData) {
            validatedData = await validateData(data);
          }
          const importResult = await importFunction(
            entityName,
            validatedData.import_id,
            validatedData.row_success,
            entityListId,
            source,
          );
          if (importResult.success) {
            successCallback(importResult.message, data);
          } else {
            errorCallback(importResult.message);
          }
        } catch (error) {
          errorCallback(`Error importing ${entityName}: ${error.message}`);
        }
      } else {
        errorCallback(
          `Failed to start ${entityName} import: Missing import ID`,
        );
      }
    } else {
      errorCallback(`Failed to upload the CSV file for ${entityName}`);
    }
  };
};

export const createCSVImportCallbackCampaign = (
  successCallback,
  errorCallback,
) => {
  return (result, data) => {
    if (result) {
      if (data.import_id) {
        const metaData = {
          file_name: data.original_filename,
          import_id: data.import_id,
          total_rows: data.row_count,
          row_success: data.row_success,
        };
        successCallback(metaData);
      } else {
        errorCallback("Failed to start import: Missing import ID");
      }
    } else {
      errorCallback("Failed to upload the CSV file");
    }
  };
};
